import { render, staticRenderFns } from "./LegalFooter.vue?vue&type=template&id=3d57492c&scoped=true&"
import script from "./LegalFooter.vue?vue&type=script&lang=js&"
export * from "./LegalFooter.vue?vue&type=script&lang=js&"
import style0 from "./LegalFooter.vue?vue&type=style&index=0&id=3d57492c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d57492c",
  null
  
)

export default component.exports